import { useTranslation } from '@/i18n/client';
import { Button } from '@mui/material';
import style from './style.module.scss';

const ReceiveTheCodeDom = ({ closeDialog }: { closeDialog: () => void }) => {
  const { t } = useTranslation();
  return (
    <div className={style.receiveTheCodeWrap}>
      <div className={style.title}>{t('login.common.notReceive')}</div>
      <div className={style.list}>
        <p>{t('login.signin.codeNotReceive.tip1')}</p>
        <p>{t('login.signin.codeNotReceive.tip2')}</p>
        <p>{t('login.signin.codeNotReceive.tip3')}</p>
        <p>{t('login.signin.codeNotReceive.tip4')}</p>
      </div>
      <div className={style.footer}>
        <Button
          sx={{
            width: '74px',
            height: '32px',
            fontSize: '16px',
            margin: '25px 0',
            color: '#fff', // 自定义文字颜色
            backgroundColor: '#CC0C1C', // 自定义背景颜色
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#990915', // 悬停时的背景颜色
            },
            '&.Mui-disabled': {
              backgroundColor: '#FF9FA7',
              color: '#fff',
            },
          }}
          onClick={() => closeDialog && closeDialog()}
        >
          {t('login.common.ok')}
        </Button>
      </div>
    </div>
  );
};

export default ReceiveTheCodeDom;
